import $ from "jquery";
import { Controller } from "@hotwired/stimulus";
import Swiper from "swiper/bundle";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// Connects to data-controller="tips"
export default class extends Controller {
  windowWidth = $(window).width();
  breakpoint = 768; // ブレークポイントを768pxに設定
  static targets = ["tipsSliderItem", "tipsSliderController", "tipsSliderControllerButton"];

  connect() {
    window.addEventListener("resize", this.handleResize);
    if (this.windowWidth < this.breakpoint && this.tipsSliderItemTargets.length > 1) {
      // SPの場合（スライドが2枚以上）
      $(this.tipsSliderControllerTarget).show();
      this.initializeSwiper();
    } else {
      // PCの場合
      $(this.tipsSliderControllerTarget).hide();
      this.destroySwiper();
    }
  }

  disconnect() {
    window.removeEventListener("resize", this.handleResize);
  }

  initializeSwiper() {
    this.swiper = new Swiper(".js-dashboard-tips-slider", {
      lazy: true,
      loop: this.tipsSliderItemTargets.length > 2,
      speed: 300,
      slidesPerView: "auto",
      centeredSlides: true,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".js-dashboard-tips-slider-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".js-dashboard-tips-slider-next",
        prevEl: ".js-dashboard-tips-slider-prev",
      },
      // キーボード操作
      keyboard: {
        enabled: true,
      },
    });
  }

  destroySwiper() {
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = undefined;
    }
  }

  handleResize = () => {
    const newWindowWidth = window.innerWidth;
    if (
      this.windowWidth >= this.breakpoint &&
      newWindowWidth < this.breakpoint &&
      this.tipsSliderItemTargets.length > 1
    ) {
      // PCからSPに切り替わる時（スライドが2枚以上）
      $(this.tipsSliderControllerTarget).show();
      this.initializeSwiper();
    } else if (this.windowWidth < this.breakpoint && newWindowWidth >= this.breakpoint) {
      // SPからPCに切り替わる時
      $(this.tipsSliderControllerTarget).hide();
      this.destroySwiper();
    }
    // 新しい画面幅を記録
    this.windowWidth = newWindowWidth;
  };

  // 再生/停止ボタン
  slider_stop() {
    if (this.tipsSliderControllerButtonTarget.classList.contains("is-pause")) {
      this.swiper.autoplay.start();
      this.tipsSliderControllerButtonTarget.classList.remove("is-pause");
      this.tipsSliderControllerButtonTarget.textContent = "停止する";
    } else {
      this.swiper.autoplay.stop();
      this.tipsSliderControllerButtonTarget.classList.add("is-pause");
      this.tipsSliderControllerButtonTarget.textContent = "再生する";
    }
  }
}
